import React from 'react';

// The CID row of the guard, supervisor and client forms. Mobiliis gives every new person their CID when they are
// first saved (laravel App\Cids: 7 digits, unique across Mobiliis); admins no longer type it. Read-only: the saved
// CID, or a note on a new form. The same person in another role keeps their one CID.
export default function CidField({ cid }) {
	const saved = cid !== null && cid !== undefined && String(cid).trim() !== '';
	return (
		<div className="row company-text-area">
			<label className="col-md-3 control-label">CID</label>
			<div className="col-md-9">
				<div className="location-text-input" style={{ border: 'none', paddingLeft: 0 }}>
					{saved ? String(cid).trim() : <span className="text-muted">Given by Mobiliis when you save</span>}
				</div>
			</div>
		</div>
	);
}
